import { render } from "./MidChatForm.vue?vue&type=template&id=61d5926c"
import script from "./MidChatForm.vue?vue&type=script&lang=js"
export * from "./MidChatForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__